import { createApp } from 'vue';
import App from './App.vue';

import './css/tailwind.css';

import prototypes from './prototypes';
prototypes();

createApp(App).mount('#app');
